export const actionTypes: any = {
  GET_SME_LOAN_START: 'GET_SME_LOAN_START',
  GET_SME_LOAN_SUCCESS: 'GET_SME_LOAN_SUCCESS',
  GET_SME_LOAN_FINISH: 'GET_SME_LOAN_FINISH',
}
